import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { globalStore } from '../../GlobalStore';

const PlatformRules: React.FC = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    globalStore.forceWhiteHeader = true;
    
    return () => {
      globalStore.forceWhiteHeader = false;
    };
  }, []);

  const sections = [
    {
      title: '一、平台服务总则',
      content: `1. 本规则适用于圆领平台（即www.yuanling.com/www.superthem.com及相关的应用程序包括但不限于[圆领]等相关的应用程序，以下简称"圆领平台"或"本平台"），圆领平台系为相关企业或其他主体（含个人）服务接收方（以下简称"买家"）和个人服务提供方（以下简称"卖家"）提供的一个技能服务交易平台。买家与卖家，均属于圆领平台的用户（以下合称"用户"）。

2. 为促进平等、开放、透明的平台生态的搭建，特制定本规则。

3. 圆领平台交易规则，是规范平台用户基本义务及规范平台用户行使基本权利的条款。

4. 用户在圆领平台的任何行为，应同时遵守与圆领平台所签订的各项协议包括但不限于《法律声明及隐私权政策》、《圆领平台服务协议》、《用户协议》，及经用户确认或签署的其他协议或相关条款。

5. 圆领平台运用自己的操作系统通过国际互联网络为用户提供网络平台服务，用户同意并确认:

(1) 自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；

(2) 自行负担个人上网所支付的与此服务有关的电话费用、网络费用；

(3) 用户是具备真实服务需求的企业或其他主体，或具备真实服务能力和服务意向的个人；

(4) 保证向本平台提供的任何资料、注册信息的真实性、正确性及完整性，包括但不限于邮箱、联系电话、手机终端通讯软件账户（如微信、微博）等。保证本平台可以通过上述联系方式与用户进行联系；

(5) 当上述资料发生变更时，及时更新用户资料，符合及时、详尽、准确的要求。

6. 若用户填写的信息不完整或不准确，则无法使用本平台服务或在使用过程中受到限制。

7. 若本平台通过技术检测、人工抽检等手段有合理理由怀疑用户资料信息造假或违背了本交易规则、用户协议或本平台的其他相关协议，平台有权暂停或终止用户的帐号，拒绝现在或将来使用平台网络服务的全部或部分，并视严重程度有权冻结或没收用户在平台的资金账户余额（含保证金），同时保留追索用户不当得利返还的权利。

8. 目前，圆领平台为用户提供"技能电商"一种服务，买卖双方为承揽关系而非雇佣关系，各自独立经营，无从属关系，买方无需为卖方提供工作工具和地点，卖方自带工作工具进行远程在线服务。买方一次性支付卖方提供的技能服务并托管费用在平台，卖方交付成果后买方对服务内容进行验收，验收完成后平台扣除一定的服务费用将剩余资金划入卖家账户。`
    },
    {
      title: '二、技能电商服务交易规则',
      content: `1. 上架规则——卖家或平台自身通过圆领平台发布技能商品，技能内容需要遵守以下条件与规则，若违反则技能商品记为无效技能商品且需承担相应法律责任，包括但不限于：

(1) 禁止发布黄色、血腥、暴力等违法内容；

(2) 禁止发布涉及政治、国家领导人等敏感内容；

(3) 平台为远程在线服务交流平台，禁止发布如线下坐班、到场工作之类的非远程工作的文字描述；

(4) 平台提供的技能商品类别已在WEB和APP系统中列出。禁止发布不属于平台允许品类范围的服务，包括但不限于问诊就医、保险销售、金融理财等；

(5) 需遵守广告法的相关规定，合法合规发布技能商品内容；

(6) 禁止发布任何性质的私人联系方式；

(7) 经平台服务人员确认，技能商品内容为虚假信息；

(8) 超过3次及以上发布无效、违规技能商品的买家，平台有权永久封禁账号。

2. 购买规则——买家通过圆领平台购买卖家所提供的技能商品服务：

(1) "技能商品"指的是卖家自主创建、上架的一个可以线上交付的服务/咨询/成果等；

(2) "技能商品"可能包含不同的规格，每个规格里，所提供的交付物、交付周期以及更多卖家自定义的内容都可能不同，买家购买即为接受卖家制定的该项技能商品的服务内容和价格。

(3) 技能商品的服务流程大致包含"支付服务"、"开启服务"、"验收服务"和"完单评价"四个节点。

(4) "支付服务"是指交易双方达成了基本的需求共识后，卖家发起订单支付请求，由买家确认下单并支付。

(5) "开启服务"是指卖家已经明确了需求的要求和明细，并获得了买家提供的材料，可以开始服务。

(6) "验收服务"是指卖家已经完成了需求实现，将商品约定的交付内容交予服务接收者验收。如买家验收成果不通过可以拒绝通过，要求卖家重新完善后重新提交。若多次（2次以上）提交验收未通过，平台将介入处理，具体解决方案视具体情况而定。

(7) "完单评价"是指卖家根据双方约定的交付内容并通过了买家验收，技能商品交易完成后，双方互相评价的行为。

3. 支付规则

(1) 当技能商品订单生成，买家如确认支付，需先通过平台提供的支付渠道支付对应金额到圆领平台代管，待买家对技能商品结果进行验收并确认后，买家此前所支付金额的85%会进入卖家可取现余额账户中。

4. 平台服务费规则

(1) 平台服务费由平台向卖家（服务提供方）统一收取。当前卖家（含超级个体和远程个体）服务费费率均为15%，涉及拉新、自介绍客户等特殊情况时，远程个体服务费费率由平台和买家、卖家协商决定，最低不低于8%。

(2) 平台服务费具体包含以下几种服务费用：平台中介费、技能商品店铺费、平台技术服务费、平台人工服务费、卖家个体灵活用工纳税和完税（此项由灵活用工服务商固定收取，平台代收）、卖家个体灵活用工税务代办费等。

(3) 任何与平台认识的客户进行的非平台服务交易均属于飞单，是逃避平台服务费的行为，一经发现，平台有权向卖家追缴逃单金额的9%作为补偿平台服务费，其余6%卖家需自行纳税。

5. 卖家收入规则

(1) 卖家可获得的服务报酬 = 服务实际交易金额 *（1-卖家服务费费率），卖家服务费费率参考本章第4条。

(2) 项目制商品和自营承揽类商品中远程个体服务商的服务实际交易金额为队长或平台所分配的报酬金额。

6. 收入发放规则

(1) 平台规定每月的10日为收入发放日，如遇节假日，一般为节假日之前一天发放，最晚在节假日之后的第一天进行发放。如遇系统异常导致收入无法准时发放的情况，平台会通过站内信或者其他通知方式告知卖家。

(2) 每月交付验收通过的订单收入总额，平台将统一于次月收入发放日（10日）自动打款，预计打款后1-3个工作日内到账；卖家需确保在后台已经绑定了本人实名认证过的银行卡号。

(3) 对于可疑、纠纷、封号的账户，平台有权暂扣卖家余额而不进行按时发放，待卖家账号解除嫌疑或相关事务处理完毕后，平台会继续择最近的收入发放日继续发放。

(4) 套用他人身份证和银行卡进行服务收款的行为是平台明确禁止的，一经发现，平台有权没收其账户所有余额和保证金账户余额（如有）。

7. 履约规则

(1) 技能商品订单生成后，双方进行需求沟通并就交易达成一致，由卖家发起支付请求，买家支付并购买技能商品订单。此后，卖家需按双方约定的交付物、交付时间来完成技能商品交付，中途卖家不得无故终止订单。

(2) 技能商品交付过程中，若卖家对交付内容产生疑问，需及时与买家沟通解决，保障技能商品如约交付。若由于买家的需求发生变化时，应当友好协商差价，通过平台提供的加价功能或者联系客服处理来改价。

8. 买家终止规则：如卖家存在如下情形，买家可终止订单，无需承担任何费用:

(1) 进入履约中后，在买家未进行需求变更的前提下，如卖家未按约定交付时间、交付物、交付质量进行技能商品交付，且未在交付时间到期前，向买家做任何沟通和说明的。

(2) 卖家交付内容明显低于约定的交付标准，导致未能遵循交易约定的；

(3) 买家应对卖家的上述行为进行举证，举证内容可以是视频、音频、图片、文字等形式，圆领平台在收到举证材料后与卖家进行确认，卖家可举证验证是否存在上述行为；圆领平台应根据双方举证材料来进行判定买家是否可行使终止订单的权利。

9. 卖家终止规则：如买家存在如下情形，卖家可终止订单，并视情况收取一定费用或全部费用：

(1) 买家已经告知了需求，卖家已经根据需求完成了任务，但买家由于自身原因恶意拒绝验收、长期不验收、故意挑刺并拒绝提供改进建议、拒绝友好协商推进交付达成的情况。

(2) 买家已经告知了需求并且卖家开启了服务，但买家失联超过3个月（电话不通/不接、微信不回），导致卖家工作无法开展的；

(3) 当涉及退款时，平台会先尝试通过原路返回的方式将相关资金退回，如原路退回失败的，买家可于自下单之日后1年内再次联系平台要回相关资金。

10 纠纷订单平台终止规则：

(1) 对于已进入履约中的订单，为避免买卖双方消极处理纠纷，导致买家付了费用却无法获得如意的成果、卖家付出了劳动却无法获得回报的情况，平台将酌情对此类情况做强制处理。

(2) 服务双方因产生纠纷导致订单无法终止时间超过半年的，平台有权对服务进行终止和资金分配的权力，平台将抽取20%的超长期纠纷处理手续费（封顶人民币2000元），剩余金额一半返还买家，一半支付卖家的服务酬劳。`
    },
    {
      title: '三、自营承揽类技能电商交易补充规则',
      content: `1. 自营承揽业务的实质是平台作为虚拟队长与个人经营者（们）一起按周任务量承揽任务并按周进行交付的一种计件服务包月方案。如平台和自由职业者在某段时间内频繁为企业完成计件任务，订单数量会急剧扩大，也会因此浪费大量的时间和订单管理成本，因此自营承揽类包月业务应需求而生。远程个体的实质是个人服务商，个人服务商与平台一起承接客户的相关任务。以下卖家、远程个体、个人服务商均为一种含义。

2. 计件任务包月对客户来说是一个高效且省的任务外包方案，个人服务商在某一段时间内完成客户的多个任务而无需分多次收款，并给到客户一个优惠的包月价。批量任务包月中，平台和远程个体仅对批量任务的交付结果负责，对项目本身的成功与失败不负责（除非远程个体本身的任务就是对项目成果负责）、也不享有权利。远程个体和平台为联合接单的关系，平台为主接单人，主要提供过程管理工具（麻雀交付管理系统）、个人服务商寻找、筛选和初面、个人服务商远程交付方法培育、个人服务商更换、交付进度跟踪、续费跟进和管理、纠纷处理和个人服务商统筹协调等服务。

3. 首次购买规则：买家按自然月购买承揽类商品，首次购买可以购买至当月月底；如首次购买服务开始时间为月末，则建议一并购买本月和次月。

4. 按月续费规则：企业可视自身需要在每个自然月月底之前支付下个月的订单。如项目接近尾声，需要购买不足单月的服务，可以联系平台重新计算价格后支付。

5. 平台建议客户按照周交付进行任务管理（客户有权拒绝选择此方式），客户和个人服务商每周协商确认好下一周的任务，个人服务商在下一周完成自己承诺的任务，所有的任务清单都记录在麻雀系统中。麻雀交付管理系统（也叫麻雀远程团队管理系统）由平台统一提供，平台作为批量任务承接人，为客户提供麻雀系统中10个非圆领账号的使用权），客户可以拒绝使用。如不使用麻雀交付管理工具的，客户需要自行提供类似工具，以便做好交付过程记录和应对意外纠纷。若客户未能提供类似工具而导致纠纷无法追溯的，一切后果由客户自行承担。

6. 远程个体和客户之间是平等的商业合作关系，远程个体只需在自己承诺的截止日期前完成任务，没有上下班和考勤的概念，也无需签到打卡，平台或客户不需要也不得为个人服务商指定工作地点或工作时长。

7. 个人服务商为具有完全民事行为能力的自然人，其由于自身操作有意或者无意导致平台或客户重大损失的，由其承担所有民事或刑事责任，一般损失优先通过友好协商解决。

8. 平台在承诺的服务项内，由于自身原因造成客户重大损失的，平台承担所有民事或刑事责任，一般损失优先通过友好协商解决。

9. 个人服务商承诺在前三天免费服务，如客户或平台对其不满意可以无条件与个人服务商解约并拒绝支付任何费用，如客户满意继续合作的，费用则从第一天开始算起。

10. 个人服务商无法及时完成承诺任务时并消极应对的，或经常性无法及时完成承诺任务的（具体任务需要留档在对应的任务管理系统中），平台和客户有权立即终止个人服务商的服务，并且拒绝支付该任务对应的费用。

11. 个人服务商的任务量必须在充分尊重个人服务商自身判断下与其协商敲定，个人服务商有权拒绝不合理的、明显超出常规周任务量的任务。

12. 在客户、平台、个人服务商友好协商的基础上进行任务量减少或者增加的，三方可以按照自行约定的方法进行费用减少或者增加。平台建议采用平均用时法来计算应退应加费用，即："包月费用*该任务正常做完所需要的人日/当月工作日总数"。

13. 服务订单合约周期内，双方均不可以随意终止服务。经双方友好协商后可随时终止服务。订单完成后，个人服务商有权自主选择新的服务对象，客户可以通过预下单的方式锁定对应的个人服务商。

14. 为防止个人服务商毁约（买家已预付费给平台），个人服务商需要缴纳25%月度酬劳的保证金，最低2000，上不封顶。

15. 双方通过友好协商，可自愿要求彼此缴纳一定的"终止提前预告"保证金：客户需保证会提前两周告知平台或者个人服务商次月不再续费；个人服务商需要保证会提前两周告知平台或客户次月不再提供服务。保证金金额可由双方经平台协商决定，一旦一方违约，保证金将赔付给另一方，并且平台和另一方有权追究违约方的法律责任。

16. 个人服务商有义务确保自己填写的资料信息的真实性，绝不隐瞒事实，绝不欺瞒平台和平台客户。如由此造成严重后果的，平台将扣除个人服务商的保证金和账户余额，个人服务商将承担所有法律责任。

17. 个人服务商与客户不得进行私下交易，当客户提出此类要求时必须果断拒绝。如发现私下交易的，平台将对卖家（个人服务商）和买家（客户）分别处以2万元罚款，优先扣除保证金，后再从余额扣除，额度不足的，平台将向卖家和买家追缴罚款，拒绝缴纳的，平台将在上海魔法向量公司所在地上海对卖家（个人服务商）和买家（客户）依法提起诉讼。

18. 个人服务商和平台均承诺在法定工作日特定时间段随时响应客户的沟通请求，以便双方更好的沟通和确保任务高质量完成。其中个人服务商及时响应的时间段由客户和个人服务商经平台协商决定。如个人服务商在承诺的时间段内超过3次不能及时响应（5分钟内未响应）平台或者客户的沟通请求，则会被认定为服务质量不合格，平台或客户有权立即终止个人服务商的服务。如个人服务商有事外出或无法及时响应时需要提前向平台和客户方负责人报备，如个人服务商由于无法及时响应而提前报备超过5次的，同服务质量不合格论处，平台或客户有权终止个人服务商的服务。

19. 非工作日如发生由于个人服务商交付的成果发生问题而发生紧急待处理事件时，个人服务商有义务无条件主动进行处理和解决，否则同服务质量不合格论处，造成严重后果的，平台和客户将依法追究其法律责任。

20. 所有承揽类包月业务合作中，个人服务商的最后一个任务一定是资料和相关知识交接，但客户有权选择无需交接。一旦服务完成后，人才服务商和客户均可以选择不再继续合作，因此客户方需要预留好任务交接的时间，建议一般最后两周用于交接。如未来得及交接的或个人服务商恰好在月底提出后续不再继续服务的（意味着客户没有时间安排交接任务），客户可通过支付相应的交接任务费用并要求个人服务商完成交接任务，个人服务商有义务完成交接任务，否则无法拿回保证金并且视为违法此协议，需要承担相应的法律责任。

21. 服务成单后，平台会负责订单管理，卖家（个人服务商）会在自己的订单列表里看到一个订单，但无需操作。订单每月月底自动验收，款项打入卖家账号余额中，并于次月10日发放到卖家银行账户中。

22. 自营承揽业务休假策略：客户和平台无权干预个人服务商的节假日时间，个人服务商作为个体经营者，有权决定自己的放假和作息时间，因此个人服务商有权自主决定法定节假日的安排，但若由于个人服务商负责的任务成果出现问题时，个人服务商有义务第一时间积极进行处理，否则会被认定为服务质量不合格。客户不能故意"编造服务质量问题"来威胁个人服务商节假日执行任务，一经发现，情节恶劣的，平台将协助个人服务商通过法律途径维护个人服务商合法权益。

23. 若客户与个人服务商合作良好或由于其他原因，准备后续转成劳动关系或其他双方协议用工的，买方需要一次性支付买断费用2万元给平台。否则违背了《平台交易规则》第四条，平台将在魔法向量公司所在地（上海）人民法院依法对买方企业提起民事诉讼。

24. 根据《关于维护新就业形态劳动者劳动保障权益的指导意见》，个人服务商依托圆领平台自主开展经营活动、从事自由职业的活动，属于平台灵活就业人员。个人服务商与平台，个人服务商与客户均没有法律劳动关系。

25. 买方企业和圆领平台上的个人服务商之间的协作、沟通和任务交付均应当通过远程进行。如双方自愿进行线下见面或合作，双方应当自行协商好意外人身受伤的双方责任认定、安全保障等事项，以应对可能出现的极端情况。对于双方线下协作导致的任何事故，圆领平台不负任何责任。

26. 服务期间如遇到特殊情况请联系平台客服处理。`
    },
    {
      title: '四、 卖家人才买断规则',
      content: `1. 平台的绝大部分卖家人才是被平台付费投放广告或付费建设的品牌形象吸引来平台，卖家从入驻开始，平台就进行了严格的筛选和培育，平台投入了大量的人力物力来经营平台。根据《平台用户协议》，只要是平台上接触认识的双方一定要在平台上交易，这是红线规定，违规必究。

2. 任何买家主张发起的非平台交易行为均属于买断场景，买断场景需要买卖双方自行处理税务事宜，以符合国家法律法规要求。

3. 若买家想买断自经营的超级个体卖家，签订其他的劳务、劳动合同，可一次性支付1万元买断费。如此双方则为合规操作，不属于违规。

4. 若买家想买断自营承揽服务中接触到的远程个体，则需要一次性支付2万元买断费（平台在远程个体远程交付方法、工具使用培育上有额外投入）。如此双方则为合规操作，不属于违规。`
    },
    {
      title: '五、 第三方服务付费规则',
      content: `1. 第三方服务付费规则适用于当个人卖家需要引入第三方企业/工作室/机构等单位来为买家提供完整的服务的情形。

2. 任何引入第三方的行为必须事先向平台客服或相应工作人员报备，客服联系方式请在PC端网站底部获取。

3. 引入第三方服务的本质是转包，个人卖家必须提供引入第三方的必要性证明。如属于能通过平台其他卖家进行服务的情况不允许引入第三方服务机构。

4. 如第三方服务是具备一定公信力的（比如淘宝、京东、国家单位）法人单位，资金可以直接由买家线下支付给卖家，只需要提供向第三方公信力单位的等额转账证明即可。

5. 如第三方服务不具备广泛的公信力（比如工作室、小企业等）时，卖家必须告知买家自己引入了第三方服务机构，并且得到买家的书面允许（微信聊天记录等）。

6. 如第三方服务不具备广泛的公信力（比如工作室、小企业等）时，所有资金交易必须走平台，由卖家统一收取。卖家自行与第三方洽谈交易细节。一经发现买家支出的资金未经平台的，一律视作逃单处理。

7. 以上涉及的各项证明必须如实开具，一旦涉及造假，平台不仅会对违规卖家进行永久封号处理，情节严重的平台还将在魔法向量所在地上海依法对卖家提起民事诉讼。`
    },
    {
      title: '六、 平台规则的修订和更新',
      content: `1. 本平台规则可由圆领平台进行修改或更新（简称"更新"），并通过以网页公告或APP站内信方式告知用户更新的内容，若用户不同意修改可通过注销账号解除其与本平台之间的协议，用户之间的订单或服务协议也随之相应终止，但用户之间正在履行的协议可在解除当期的服务月届满后按原规则结算；若公告期（7日）满后用户继续使用的，视为接受更新。用户可在圆领平台的网站[www.yuanling.com/www.superthem.com] 【协议与规则】内或APP软件中【我的】内查阅最新版平台规则。除非用户在新平台规则生效前已经享有的事项，否则用户的权利及义务、购买相关程序及收费标准均以最新的平台规则中各条款为准。

2. 历史版本的协议请联系平台客服获取，不同版本的协议对用户行为有不同的约束，历史协议依旧具有法律效力。`
    },
    {
      title: '七、 免责申明',
      content: `1. 平台有义务制定符合法律、道德的平台规则并尽力落实。如发现任何刻意伪造资料或刻意绕过平台系统漏洞而发布的不符合法律法规或国家相关文件的信息，请及时向平台客服举报，平台有义务进行及时处理。但对于防不胜防的场景，平台具有解释权和免责权。

2. 买卖双方基于双方自愿、通过平台自由沟通进行了交易。当双方发生纠纷时应当先尝试自行协商解决，协商解决无效的平台可以从中发挥积极的调解作用，力所能及的方面将给出专业意见，但平台不承担任何非产品系统设计严重缺陷所导致纠纷的责任。`
    },
    {
      title: '八． 附章',
      content: `1. 用户应遵守国家法律、行政法规、部门规章等规范性文件。对任何涉嫌违反国家法律、行政法规、部门规章等规范性文件的行为，本规则已有规定的，适用于本规则。本规则尚无规定的，圆领平台有权酌情处理。但圆领平台另立对用户方的处理不免除其应承担的法律责任。用户的任何行为，应同时遵守与圆领平台及其关联公司签订的各项协议。`
    }
  ];

  return (
    <>
      <style>{`
        .rules-wrapper {
          background-color: #ffffff;
          min-height: 100vh;
        }
        .rules-container {
          max-width: 1400px;
          margin: 0 auto;
          width: 100%;
          padding: 60px 40px;
        }
        @media (max-width: 767px) {
          .rules-container {
            padding: 40px 16px;
          }
        }
      `}</style>
      <div className="rules-wrapper">
        <div className="rules-container">
        {/* 标题（居中） */}
        <h1 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '20px',
          color: '#000000'
        }}>
          圆领平台交易规则
        </h1>
        
        {/* 发布时间-生效时间（居中） */}
        <div style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#666666',
          marginBottom: '40px'
        }}>
          2024年04月08日生效
        </div>
        
        {/* 正文：多个章节 */}
        <div style={{
          fontSize: '16px',
          lineHeight: '28px',
          color: '#333333'
        }}>
          {sections.map((section, index) => (
            <div key={index} style={{ marginBottom: '30px' }}>
              <h2 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                marginBottom: '12px',
                color: '#000000'
              }}>
                {section.title}
              </h2>
              <div style={{
                fontSize: '16px',
                lineHeight: '28px',
                fontWeight: '400',
                color: '#333333',
                whiteSpace: 'pre-wrap'
              }}>
                {section.content}
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
    </>
  );
});

export default PlatformRules;
